import script from "./ShortcutGridItem.vue?vue&type=script&setup=true&lang=js"
export * from "./ShortcutGridItem.vue?vue&type=script&setup=true&lang=js"

import "./ShortcutGridItem.vue?vue&type=style&index=0&id=2b135481&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b135481"]])

export default __exports__